export default __webpack_public_path__ + "static/media/resume.b0d19c84.pdf";